<template>
  <div class="list-control-panel p-4 border border-dark">
    <div class="row">
      <div class="col-md col">
        <label for="sort-option" class="me-md-3 me-2">排序依據</label>
        <select id="sort-option" class="form-select d-inline-block w-auto bg-solid border-0 loft-text-highlight" :value="sort" @change="changeSort($event.target.value)">
          <option v-for="(item, index) in sortOptions" :key="`sort-${index}`" :value="item.value">{{ item.name }}</option>
        </select>
      </div>
      <div class="col-md-auto d-none d-md-block">
        <label for="limit-option" class="me-3">顯示</label>
        <div class="btn-group">
          <button class="btn p-0 me-3" v-for="(item, index) in limitOptions" :key="`limit-${index}`" :class="{ 'loft-text-highlight': Number(limit) === item }" @click="changeLimit(item)">{{ item }}</button>
        </div>
      </div>
      <div class="col-auto">
        <label class="me-3 d-none d-md-inline-block">顯示方式</label>
        <img class="icon me-md-3 me-2" :src="layout === layoutOptions.GRID ? require('@/assets/img/ic-grid-selected.svg') : require('@/assets/img/ic-grid.svg')" @click="changeLayout(layoutOptions.GRID)">
        <img class="icon"  :src="layout === layoutOptions.LIST ? require('@/assets/img/ic-list-selected.svg') : require('@/assets/img/ic-list.svg')" @click="changeLayout(layoutOptions.LIST)">
      </div>
    </div>
  </div>
</template>

<script>
import constant from '@/constant.js'

export default {
  name: 'ListControlPanel',
  props: {
    layout: {
      type: String,
      default: 'grid'
    },
    sort: {
      type: String,
      default: 'lastUpdate;desc'
    },
    limit: {
      type: Number,
      default: 24
    }
  },
  computed: {
    layoutOptions: function () {
      return constant.PRODUCT_LAYOUT
    },
    limitOptions: function () {
      return constant.FILTER.LIMIT
    },
    sortOptions: function () {
      return constant.FILTER.SORT
    }
  },
  methods: {
    changeLayout: function (layout) {
      this.$emit('layout', layout)
    },
    changeSort: function (value) {
      this.$emit('sort', value)
    },
    changeLimit: function (value) {
      this.$emit('limit', Number(value))
    }
  }
}
</script>

<style scoped>
.list-control-panel * {
  font-size: 1.1rem !important;
  vertical-align: middle;
}
#sort-option {
  background: none;
  padding: 0;
  vertical-align: middle;
  cursor: pointer;
}
.icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
</style>
